var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33325 3.5H9.33325C10.5709 3.5 11.7579 3.99167 12.6331 4.86683C13.5083 5.742 13.9999 6.92899 13.9999 8.16667V24.5C13.9999 23.5717 13.6312 22.6815 12.9748 22.0251C12.3184 21.3687 11.4282 21 10.4999 21H2.33325V3.5Z",
    stroke: "#8F9DAC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 3.5H18.6667C17.429 3.5 16.242 3.99167 15.3668 4.86683C14.4917 5.742 14 6.92899 14 8.16667V24.5C14 23.5717 14.3687 22.6815 15.0251 22.0251C15.6815 21.3687 16.5717 21 17.5 21H25.6667V3.5Z",
    stroke: "#8F9DAC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/AddressBook.0a2dabb0bff295d5d028345e50b9860c.svg";
export { ForwardRef as ReactComponent };